:host{display:flex;flex-direction:row;flex:1;min-height:0}
/*# sourceMappingURL=image.component-TF3K4GNE.css.map */
